import { tProgrammedMessageActionContext } from './ProgrammedMessageAction.types';

export const initialState: tProgrammedMessageActionContext = {
  loading: false,
  setLoading: () => {},
  triggerDate: '',
  triggerTime: '',
  localDate: '',
  localTime: '',
  setTriggerDate: () => {},
  setTriggerTime: () => {},
  followUpAttachments: [],
  setFollowUpAttachments: () => {},
  handleTriggerDateTimeChange: () => {},
  createNewFollowUp: async () => true,
  deleteFollowUp: async () => {},
  updateEvent: () => {},
  isDateInPast: false,
  isEmpty: true,
  wapiScheduleLimit: null,
  maxDate: null,
  maxTime: null,
};
